import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { hiddenCategories } from "../Constants/hiddenCategories";
import { getPreferredListings, getListings } from "../Services/listingsApi";
import { getCities,getCategoriesByCityId} from "../Services/citiesApi";
import { getCategory } from "../Services/CategoryApi";
import { getCurrentUser } from "../Services/usersApi";
import TerminalDefaultBackground from '../assets/Terminal-Background.png';
import CITYDEFAULTIMAGE from "../assets/CityDefault.png";
import ShopingCart from "../assets/dummyimage.jpg";
import { fetcTerminalData } from "../Services/terminal";
import ListingPopUpPreview from "../Components/ListingPopUpPreview";
import { categoryIcons } from "../Constants/categoryIcons";
import ListingsCardTerminal from "../Components/ListCardTerminal";
import ServiceViewModal from "../Components/ServicesView";
import { QrCodes } from "./HorizontalCompo";
import { ServicesHorizontal } from "./HorizontalCompo";
import { ArrowUp, ArrowDown } from "lucide-react";
import useScrollableDown from "../hook/useScrollableDown";
import { isSolidColorImage, prioritizeItemsByKey } from "../Services/helper";
import { categoryByName } from "../Constants/categories";
import { VerticalQrCodes, VerticalServices } from "./VerticalCompo";
import { useInactivity } from "../hook/useInActivity";
import {
  DEFAULT_ROTATE_ADS,
  TERMINAL_INACTIVITY_TIME,
} from "../Constants/constant";
import { useRotator } from "../hook/useRotator";
import DisplayAdvertisement from "../Components/DisplayAdvertisement";
import { useActiveAds } from "../hook/useActiveAds";
import useAutoThemeLock from "../hook/useAutoThemeLock";

function TerminalViewSkeleton() {
  return (
    <div className="animate-pulse relative">
      {/* Background */}
      <div className="absolute inset-0 -z-10 w-full h-full bg-gray-100"></div>

      {/* Wrapper */}
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Listings Section */}
        <div className=" w-full lg:w-[46%] flex flex-col justify-center items-center mt-2 wspace-y-4">
          <div className="flex flex-wrap justify-center gap-4 w-full">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="w-[20rem] h-[15rem] bg-gray-200 rounded-lg"
              ></div>
            ))}
          </div>
        </div>
        {/* Vertical Bar */}
        <div className="hidden lg:flex h-[100vh] flex-col justify-center">
          <div className="w-2 h-[90vh] bg-gray-300"></div>
        </div>
        {/* Right Content */}
        <div className="w-full lg:w-[46%] self-start space-y-10">
          {/* Services Label */}
          <div className="w-full flex justify-center items-center mt-24 mb-4">
            <div className="h-10 w-48 bg-gray-300 rounded"></div>
          </div>

          {/* Services Grid */}
          <div className="flex flex-wrap justify-center gap-4 w-full px-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="w-[25rem] h-[20rem] bg-gray-200 rounded-lg"
              ></div>
            ))}
          </div>

          {/* QR Codes Label */}
          <div className="w-full flex justify-center items-center mt-24 mb-4">
            <div className="h-10 w-48 bg-gray-300 rounded"></div>
          </div>

          {/* QR Codes Grid */}
          <div className="flex flex-wrap justify-center gap-4 w-full px-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="flex flex-col justify-end border rounded-lg bg-gray-50 w-[25rem] h-[20rem] p-4 space-y-2"
              >
                <div className="h-8 w-32 bg-gray-300 rounded"></div>
                <div className="h-32 w-full bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const ScrollerStruct = ({ children, terminalData, className }) => {
  const scrollListingRef = useRef(null);

  const scrollListingLeft = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollListingRight = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <>
      {terminalData?.orientation !== "horizontal" && (
        <button
          onClick={scrollListingLeft}
          className="absolute left-2 top-1/2  z-20 -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
        >
          ❮
        </button>
      )}
      <div ref={scrollListingRef} className={className}>
        {children}
      </div>
      {terminalData?.orientation !== "horizontal" && (
        <button
          onClick={scrollListingRight}
          className="absolute right-2 top-1/2 z-20  -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
        >
          ❯
        </button>
      )}
    </>
  );
};

const HomePageTempleteA = () => {
  const { t } = useTranslation();
  const { terminalId } = useParams();
  const [cityId, setCityId] = useState([]);
  const [categoryId, setCategoryId] = useState();
  const [cities, setCities] = useState([]);
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [terminalView, setTerminalView] = useState(false);
  const [isGridView, setIsGridView] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const [terminalData, setTerminalData] = useState(null);
  const terminalViewParam = queryParams.get("terminalView");
  const [listingpopup, setListingPopup] = useState(null);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMap,setIsMap]=useState(false)
  const[poiCategories,setPoiCategories]=useState([])
  
  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled =
    isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const [isInActivity, resetInactivity] = useInactivity(TERMINAL_INACTIVITY_TIME);

  useAutoThemeLock();
  const terminalCityId=terminalData?.cityId

  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const isScrollableA = useScrollableDown();

  useEffect(() => {
    const checkPrivacyPolicy = () => {
      const cookieVal = getCookie("privacyPolicyAcceptedGlobally");

      try {
        const parsed = JSON.parse(decodeURIComponent(cookieVal));
        if (parsed?.accepted === true) {
          setShowPopup(false);
        } else {
          setShowPopup(true);
        }
      } catch (err) {
        console.error("Invalid cookie format:", err);
        setShowPopup(true);
      }
    };

    checkPrivacyPolicy();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setTerminalView(isTerminalScreenEnabled);

    getCities()
      .then((citiesResponse) => {
        if (Array.isArray(citiesResponse?.data?.data)) {
          setCities(citiesResponse.data.data);
        } else {
          setCities([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
        setCities([]);
      });

    const cityParam = parseInt(queryParams.get("cityId"));
    if (cityParam) {
      setCityId(cityParam);
    }
    const catParam = parseInt(queryParams.get("categoryId"));
    if (catParam) {
      setCategoryId(catParam);
    }

    getCategory()
      .then((response) => {
        const allCats = response?.data?.data || [];
        const filteredCats = allCats.filter(
          (cat) => !hiddenCategories.includes(cat.id)
        );
        setCategories(filteredCats);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategories([]);
      });

    document.title = process.env.REACT_APP_REGION_NAME;
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (parseInt(categoryId)) {
      urlParams.set("categoryId", categoryId);
    } else {
      urlParams.delete("categoryId");
    }

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, "", newUrl);

    fetchData();
  }, [cityId, categoryId, searchQuery]);

  const fetchData = async (locationParams = {}) => {
    try {
      setIsLoading(true);

      const accessToken =
        window.localStorage.getItem("accessToken") ||
        window.sessionStorage.getItem("accessToken");

      let userId =
        window.localStorage.getItem("userId") ||
        window.sessionStorage.getItem("userId");

      if (!userId && accessToken) {
        try {
          const res = await getCurrentUser();
          userId = res?.data?.id;
          if (userId) {
            localStorage.setItem("userId", userId);
          }
        } catch (error) {
          console.warn("User fetch failed, using public listings instead.");
        }
      }
    } catch (error) {
      console.error("Error fetching listings:", error);
      setListings([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  const [advertisements, setAdvertisements] = useState([]);
  const activeAds = useActiveAds(advertisements);

  useEffect(() => {
    fetcTerminalData(terminalId).then((res) => {
      const data = res.data?.data;
      // NOTE: CATEGORIES PRIORITY ARE BEING UPDATED.
      if (data?.categories?.length) {
        const categories = prioritizeItemsByKey(data?.categories, [
          categoryByName.News,
          categoryByName.Events,
        ]);
        data.categories = categories;
      }
      setTerminalData({ ...data });
      setAdvertisements(data?.advertisements || []);

      // Initialize selected category to first category with listings
      const firstCategoryWithListings = data?.categories?.find(
        (categ) => categ?.listings?.length > 0
      );
      if (firstCategoryWithListings && !selectedCategoryId) {
        setSelectedCategoryId(firstCategoryWithListings.id);
      }
    });
  }, [terminalId]);

  const [selectedService, setSelectedService] = useState("");

  // Function to handle load more/show less clicks
  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const selectedCategoryListing = useMemo(() => {
    return selectedCategoryId
      ? terminalData?.categories?.find((cat) => cat.id === selectedCategoryId)
      : terminalData?.categories?.filter(
          (categ) => categ?.listings?.length > 0
        )?.[0];
  }, [selectedCategoryId, terminalData]);

  const [firstHalfCategories, secondHalfCategories] = useMemo(() => {
    const arr = selectedCategoryListing?.listings;
    if (arr?.length > 6) {
      const half = Math.ceil(arr.length / 2);
      return [arr.slice(0, half), arr.slice(half)];
    } else {
      return [arr]; // Return as a single group if 6 or less
    }
  }, [selectedCategoryListing]);

  const categoryListingsCount = useMemo(() => {
    const selectedCategory = selectedCategoryId
      ? terminalData?.categories?.find((cat) => cat.id === selectedCategoryId)
      : terminalData?.categories?.filter(
          (categ) => categ?.listings?.length > 0
        )?.[0];
    return selectedCategory?.listings?.length || 0;
  }, [selectedCategoryId, terminalData]);

  useEffect(() => {
    if (terminalData?.header_url) {
      isSolidColorImage(terminalData?.header_url).then((res) => {
        if (res?.color) {
          const overlayEl = document.getElementById("header-image-overlay");
          if (overlayEl) {
            overlayEl.classList.remove("bg-gray-700");
            overlayEl.classList.remove("bg-opacity-75");
            if (res?.light) {
              overlayEl.classList.remove("text-white");
            }
          }
        }
      });
    }
  }, [terminalData]);


      const getCategories=useCallback(async(terminalCityId)=>{
        try{
        const {data}=await getCategoriesByCityId(terminalCityId)
        if(data?.status){
          setPoiCategories(data?.data)
        }
        }catch(e){
          console.error(e)
        }
      },[])
  
      useEffect(() => {
          if (terminalCityId) {
            // getPoiForTerminal(cityId);
            getCategories(terminalCityId)
          }
        }, [terminalCityId, getCategories]);

  return (
    <section
      className="text-gray-900 body-font relative"
      onClick={() => setListingPopup(null)}
    >
      <div>
        {listingpopup && (
          <ListingPopUpPreview
            listing={listingpopup}
            setListingPopup={setListingPopup}
          />
        )}
        <div className="flex flex-col relative p-0">
          {/* Logo */}
          <div
            style={{
              backgroundImage: `url(${
                terminalData?.logo_url || TerminalDefaultBackground
              })`,
            }}
            className="absolute z-20 lg:left-2 xl:left-4 xl:top-2 md:top-4 h-10 w-10 sm:h-28 sm:w-28 lg:h-24 lg:w-28 xl:h-28 2xl:w-30 2xl:h-30 3xl:w-40 3xl-w-40 rounded bg-center bg-no-repeat bg-contain"
            aria-label="Logo"
          />

          {/* Header Image */}
          <div className="w-full">
            <div className="relative h-[14vh] w-full aspect-[16/9] overflow-hidden">
              <img
                alt="ecommerce"
                className="object-cover object-center w-full h-full"
                src={terminalData?.header_url || TerminalDefaultBackground}
                loading="lazy"
              />
              <div
                id="header-image-overlay"
                className="absolute inset-0 flex flex-col items-center justify-center bg-gray-700 bg-opacity-75 text-white"
              >
                <h1
                  className="text-center font-bold tracking-wide"
                  style={{
                    fontFamily:
                      "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                    fontSize: "clamp(1rem,1.3vw,2rem)",
                  }}
                >
                  {terminalData?.cityHeader || t("homePageHeading")}
                </h1>
              </div>
              <div className="absolute inset-0 w-full mt-4 flex flex-col items-left justify-end">
                <div className="flex overflow-x-auto gap-4 md:gap-8 px-4 md:px-20 lg:px-32 xl:px-40 scrollbar-hide snap-x">
                  {terminalData?.categories
                    ?.filter((categ) => categ?.listings?.length > 0)
                    ?.map((category, index) => {
                      const isSelected = selectedCategoryIndex === index;
                      const categoryId = category.id;
                      const categoryIcon = categoryIcons[categoryId]?.svgIcon;
                      return (
                        <h2
                          key={categoryId}
                          className={`flex items-center gap-2 font-bold p-1 md:p-1 rounded-t-xl 
                            text-lg 3xl:text-[1rem]
                            truncate 
                            ${
                              terminalData.orientation !== "horizontal" &&
                              "2xl:text-[1rem] mx-4"
                            }
                            
                             cursor-pointer snap-start whitespace-nowrap ${
                               isSelected
                                 ? "bg-white text-gray-800"
                                 : "text-white hover:text-gray-400"
                             }`}
                          style={
                            terminalData.orientation !== "horizontal"
                              ? {
                                  fontFamily:
                                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                                }
                              : {
                                  fontFamily:
                                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                                  fontSize: "clamp(0.5rem, 0.6vw, 1rem)",
                                }
                          }
                          onClick={() => {
                            setSelectedCategoryIndex(index);
                            setSelectedCategoryId(category.id);
                            setIsExpanded(false); // Reset expanded state when changing category
                          }}
                        >
                          {categoryIcon && (
                            <svg
                              className={`h-2  w-3 md:h-3 md:w-4 fill-current 
                                ${
                                  terminalData.orientation !== "horizontal" &&
                                  "2xl:h-[2rem]"
                                }
                                `}
                              viewBox={
                                categoryIcons[categoryId]?.viewBox ||
                                "0 0 512 512"
                              }
                            >
                              <path d={categoryIcon} />
                            </svg>
                          )}
                          {t(category.name)}
                        </h2>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>

          {/* Categories */}

          {/* Loading / Inactive State */}
          {isLoading ? (
            <TerminalViewSkeleton />
          ) : (
            <>
              {activeAds.length > 0 && isInActivity && (
                <DisplayAdvertisement advertisements={activeAds} onClose={resetInactivity} />
              )}

              {/* Background */}
              <div
                className="absolute inset-0 -z-10 bg-cover bg-no-repeat opacity-10 min-h-screen"
                style={{
                  backgroundImage: `url(${
                    terminalData?.background_url || TerminalDefaultBackground
                  })`,
                }}
              />

              {/* Main Content */}
              <div
                className={`flex flex-col ${
                  terminalData?.orientation === "horizontal"
                    ? "lg:flex-row lg:gap- xl:gap-6"
                    : "flex-col gap-6"
                }`}
              >
                {/* Listings ------------ Vertical FOR Length === 1*/}
                {terminalData?.orientation === "vertical" ? (
                  <>
                    {/* PART 1 : SCROLLER */}
                    <div className="relative w-full h-fit">
                      <ScrollerStruct
                        terminalData={terminalData}
                        className={`flex gap-4 px-4 py-0 snap-x ${
                          terminalData?.orientation !== "horizontal"
                            ? "overflow-x-auto scrollbar-hide"
                            : "flex-row flex-wrap justify-center"
                        }`}
                      >
                        {(() => {
                          const currentListings = firstHalfCategories || [];
                          const itemsToShow =
                            terminalData?.orientation === "horizontal" &&
                            !isExpanded
                              ? 6
                              : currentListings.length;
                          const displayedListings = currentListings.slice(
                            0,
                            itemsToShow
                          );

                          return displayedListings.map((listing, idx) => (
                            <div
                              key={idx}
                              className="flex-shrink-0 snap-start"
                              onClick={(e) => {
                                e.stopPropagation();
                                setListingPopup(listing);
                              }}
                            >
                              <p
                                className="px-4 opacity-0 text-gray-900 font-bold text-2xl 3xl:text-[4rem]  title-font text-start font-sans font-bold flex justify-between items-center"
                                style={{
                                  fontFamily:
                                    "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                                }}
                              >
                                {"hidden"}
                              </p>
                              <ListingsCardTerminal
                                listing={listing}
                                terminalView={terminalView}
                                isPopUp
                                setListingPopup={setListingPopup}
                                orientation={terminalData?.orientation}
                                type={"A"}
                              />
                            </div>
                          ));
                        })()}
                      </ScrollerStruct>
                    </div>
                    {/* PART 2 : SCROLLER */}
                    {!!secondHalfCategories?.length && (
                      <div className="relative w-full h-fit">
                        <ScrollerStruct
                          terminalData={terminalData}
                          className={`flex gap-4 px-4 py-0 snap-x ${
                            terminalData?.orientation !== "horizontal"
                              ? "overflow-x-auto scrollbar-hide"
                              : "flex-row flex-wrap justify-center"
                          }`}
                        >
                          {(() => {
                            const currentListings = secondHalfCategories || [];
                            const itemsToShow =
                              terminalData?.orientation === "horizontal" &&
                              !isExpanded
                                ? 6
                                : currentListings.length;
                            const displayedListings = currentListings.slice(
                              0,
                              itemsToShow
                            );

                            return displayedListings.map((listing, idx) => (
                              <div
                                key={idx}
                                className="flex-shrink-0 snap-start"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setListingPopup(listing);
                                }}
                              >
                                <p
                                  className="px-4 opacity-0 text-gray-900 font-bold text-2xl 3xl:text-[4rem]  title-font text-start font-sans font-bold flex justify-between items-center"
                                  style={{
                                    fontFamily:
                                      "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                                  }}
                                >
                                  {"hidden"}
                                </p>
                                <ListingsCardTerminal
                                  listing={listing}
                                  terminalView={terminalView}
                                  isPopUp
                                  setListingPopup={setListingPopup}
                                  orientation={terminalData?.orientation}
                                  type="A"
                                />
                              </div>
                            ));
                          })()}
                        </ScrollerStruct>
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    className={`mt-0 flex flex-row px-4 justify-center ${
                      terminalData?.orientation === "horizontal" &&
                      (terminalData?.qrCodes?.length > 0 ||
                        terminalData?.services?.length > 0)
                        ? "lg:w-1/2"
                        : "w-full"
                    }`}
                  >
                    {(() => {
                      const selectedCategory = selectedCategoryId
                        ? terminalData?.categories?.find(
                            (cat) => cat.id === selectedCategoryId
                          )
                        : terminalData?.categories?.filter(
                            (categ) => categ?.listings?.length > 0
                          )?.[0];
                      return selectedCategory?.listings?.length > 0;
                    })() && (
                      <>
                        <div className="relative w-full h-fit">
                          <ScrollerStruct
                            terminalData={terminalData}
                            className={`flex gap-4 px-4 mt-4 py-0 snap-x ${
                              terminalData?.orientation !== "horizontal"
                                ? "overflow-x-auto scrollbar-hide"
                                : "flex-row flex-wrap justify-center"
                            }`}
                          >
                            {(() => {
                              const selectedCategory = selectedCategoryId
                                ? terminalData?.categories?.find(
                                    (cat) => cat.id === selectedCategoryId
                                  )
                                : terminalData?.categories?.filter(
                                    (categ) => categ?.listings?.length > 0
                                  )?.[0];
                              const currentListings =
                                selectedCategory?.listings || [];
                              const itemsToShow =
                                terminalData?.orientation === "horizontal" &&
                                !isExpanded
                                  ? 6
                                  : currentListings.length;
                              const displayedListings = currentListings.slice(
                                0,
                                itemsToShow
                              );

                              return displayedListings.map((listing, idx) => (
                                <div
                                  key={idx}
                                  className="flex-shrink-0 snap-start"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setListingPopup(listing);
                                  }}
                                >
                                  <ListingsCardTerminal
                                    listing={listing}
                                    terminalView={terminalView}
                                    isPopUp
                                    setListingPopup={setListingPopup}
                                    orientation={terminalData?.orientation}
                                    type={"A"}
                                  />
                                </div>
                              ));
                            })()}
                          </ScrollerStruct>

                          {/* Load More / Show Less Button - Only for horizontal orientation */}
                          {categoryListingsCount > 6 &&
                            terminalData?.orientation === "horizontal" && (
                              <div className="flex justify-center mt-6">
                                <button
                                  onClick={handleToggleExpanded}
                                  className="bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
                                >
                                  {isExpanded
                                    ? "Show Less"
                                    : `Load More (${
                                        categoryListingsCount - 6
                                      } more)`}
                                </button>
                              </div>
                            )}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* Divider */}
                {terminalData?.orientation === "horizontal" &&
                  (terminalData?.qrCodes?.length > 0 ||
                    terminalData?.services?.length > 0) && (
                    <div className="hidden lg:block flex-1 items-center py-6">
                      <div className="w-1  h-full bg-gray-400"></div>
                    </div>
                  )}

                <ServiceViewModal
                  isOpen={!!selectedService}
                  url={selectedService}
                  close={() => setSelectedService("")}
                  isMap={isMap}
                  services={terminalData?.services}
                  terminalData={terminalData}
                  poiCategories={poiCategories}
                />

                {/* ELEMENT: Services + QR Codes === Horizontal */}
                {(terminalData?.qrCodes.length > 0 ||
                  terminalData?.services.length > 0) &&
                  terminalData.orientation === "horizontal" && (
                    <div className="lg:w-[48%] flex flex-col">
                      {!!terminalData?.services.length && (
                        <div>
                          <div className="font-bold text-2xl 3xl:text-[4rem] my-8 px-8 dark:text-white">
                            {terminalData?.serviceLabel || t("servicesLabel")}
                          </div>
                          <ServicesHorizontal
                            services={terminalData?.services}
                            setSelectedService={setSelectedService}
                            serviceLabel={terminalData?.serviceLabel}
                            setIsMap={setIsMap}
                            

                          />
                        </div>
                      )}
                      {!!terminalData?.qrCodes.length && (
                        <div>
                          <div className="font-bold text-2xl 3xl:text-[4rem] my-8 px-8 dark:text-white">
                            {terminalData?.qrCodeLabel || "QR Codes"}
                          </div>

                          <QrCodes
                            qrCodes={terminalData?.qrCodes}
                            qrCodeLabel={terminalData?.qrCodeLabel}
                          />
                        </div>
                      )}
                    </div>
                  )}

                {/* ELEMENT: Services + QR Codes === Vertical */}
                {terminalData?.orientation === "vertical" && (
                  <>
                    {/* Services */}
                    <VerticalServices
                      terminalData={terminalData}
                      setSelectedService={setSelectedService}
                      setIsMap={setIsMap}
                    />

                    {/* QR Codes */}
                    <VerticalQrCodes terminalData={terminalData} />
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Arrow Icons at Bottom Right */}
      {isScrollableA && terminalData?.orientation === "horizontal" && (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col space-y-2">
          <button
            className="bg-gray-800 hover:bg-gray-700 text-white p-3 rounded-full shadow-lg transition-colors duration-200"
            aria-label="Arrow Down"
          >
            <ArrowDown size={24} />
          </button>
        </div>
      )}
    </section>
  );
};

export default HomePageTempleteA;